function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default ({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("rect", {
  width: "24",
  height: "24",
  rx: "5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.486 17.03a1.297 1.297 0 00.919-.38l-.212-.212.212.212 7.072-7.072h0a1.3 1.3 0 00-1.84-1.838s0 0 0 0l-6.152 6.15-3.321-3.32a1.3 1.3 0 10-1.838 1.839l4.24 4.241h0a1.297 1.297 0 00.92.38zm0 0s0 0 0 0v-.3.3s0 0 0 0z",
  fill: "#fff",
  stroke: "#fff",
  strokeWidth: ".6"
}));